import { Directive } from '@angular/core';
import { IfCheckoutProcessDirectiveDef } from '@df/ui/common/if-checkout-process.directive.def';

@Directive({
    selector: '[ifCheckoutProcess]'
})
export class IfCheckoutProcessDirective extends IfCheckoutProcessDirectiveDef {
    protected override check(): boolean {
        const url = this.router.url;
        return !!(url.match(/^\/checkout/) && !url.match(/^\/checkout\/success/));
    }
}
